const u = Symbol.for("r2wc.reactRender"), m = Symbol.for("r2wc.shouldRender"), d = Symbol.for("r2wc.root");
function P(s = "") {
  return s.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
const j = {
  expando: function(s, a, c) {
    Object.defineProperty(s, a, {
      enumerable: !0,
      get: function() {
        return c;
      },
      set: function(r) {
        c = r, this[u]();
      }
    }), s[u]();
  }
};
function w(s, a, c, r = {}) {
  const f = {}, y = {}, b = {};
  r.props || (r.props = s.propTypes ? Object.keys(s.propTypes) : []);
  const g = Array.isArray(r.props) ? r.props.slice() : Object.keys(r.props), S = Array.isArray(r.props);
  g.forEach((e) => {
    f[e] = S ? String : r.props[e], y[e] = P(e), b[y[e]] = e;
  });
  const h = {
    isConnected: "isConnected" in HTMLElement.prototype
  };
  let l = !1;
  const p = function(...e) {
    const o = Reflect.construct(HTMLElement, e, this.constructor);
    return typeof r.shadow == "string" ? o.attachShadow({ mode: r.shadow }) : r.shadow && (console.warn('Specifying the "shadow" option as a boolean is deprecated and will be removed in a future version.'), o.attachShadow({ mode: "open" })), o;
  }, i = Object.create(HTMLElement.prototype);
  i.constructor = p;
  const A = new Proxy(i, {
    has: function(e, o) {
      return o in f || o in i;
    },
    set: function(e, o, t, n) {
      return l && (h[o] = !0), typeof o == "symbol" || h[o] || o in e ? Reflect.set(e, o, t, n) : (j.expando(n, o, t), !0);
    },
    getOwnPropertyDescriptor: function(e, o) {
      const t = Reflect.getOwnPropertyDescriptor(e, o);
      if (t)
        return t;
      if (o in f)
        return {
          configurable: !0,
          enumerable: !0,
          writable: !0,
          value: void 0
        };
    }
  });
  return p.prototype = A, i.connectedCallback = function() {
    this[m] = !0, this[u]();
  }, i.disconnectedCallback = function() {
    typeof c.createRoot == "function" ? this[d].unmount() : c.unmountComponentAtNode(this);
  }, i[u] = function() {
    if (this[m] === !0) {
      const e = {};
      Object.keys(this).forEach(function(n) {
        h[n] !== !1 && (e[n] = this[n]);
      }, this), l = !0;
      const o = r.shadow ? this.shadowRoot : this, t = a.createElement(s, e);
      typeof c.createRoot == "function" ? (this[d] || (this[d] = c.createRoot(o)), this[d].render(t)) : c.render(t, o), l = !1;
    }
  }, p.observedAttributes = Object.keys(b), i.attributeChangedCallback = function(e, o, t) {
    const n = b[e] || e;
    switch (f[n]) {
      case "ref":
      case Function:
        if (!t && f[n] === "ref") {
          t = a.createRef();
          break;
        }
        typeof window < "u" ? t = window[t] || t : typeof global < "u" && (t = global[t] || t), typeof t == "function" && (t = t.bind(this));
        break;
      case Number:
        t = parseFloat(t);
        break;
      case Boolean:
        t = /^[ty1-9]/i.test(t);
        break;
      case Object:
      case Array:
        t = JSON.parse(t);
        break;
    }
    this[n] = t;
  }, p;
}
export {
  w as default
};
